export default __webpack_public_path__ + "static/media/new-assistant-welcome-5-1.f7b7ead6.png";